import { Card, Col, Row } from "antd";
import React, { useEffect } from "react";
import { InputField } from "../../atoms/FormElement";

export const PointContact = (props) => {
  const { control, loading, editAbleRecord, setValue } = props;
  useEffect(() => {}, [editAbleRecord]);

  const defaultProps = { control };
  return (
    <Card loading={loading} title="Point of Contact" style={{ marginBottom: 10 }}>
      <Row gutter={24}>
        <Col span={8}>
          <InputField
            fieldname="pocName"
            label="POC Name"
            {...defaultProps}
            initialValue={editAbleRecord?.pocName || ""}
            // {...getValidationProps({
            //   fieldName: "workPhone",
            //   errors,
            //   //isRequired: true,
            //   rules: getMinMaxValidationRules({
            //     label: "Work Phone",
            //     // min: 9,
            //     //  max: 9,
            //   }),
            // })}
            iProps={{ placeholder: "POC Name" }}
            setValue={setValue}
            valueGot={editAbleRecord?.pocName || ""}
          />
        </Col>

        <Col span={8}>
          <InputField
            fieldname="pocPhone"
            label="Mobile Phone"
            {...defaultProps}
            //   {...getValidationProps({
            //     fieldName: "ownerPhone",
            //     errors,
            //     isRequired: true,
            //     rules: getMinMaxValidationRules({
            //       label: "Mobile Phone",
            //       min: 9,
            //       max: 9,
            //     }),
            //   })}
            iProps={{ addonBefore: "+971", placeholder: "Mobile Phone" }}
            setValue={setValue}
            valueGot={editAbleRecord?.pocPhone || ""}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="pocWorkPhone"
            label="Work Phone"
            {...defaultProps}
            //   {...getValidationProps({
            //     fieldName: "workPhone",
            //     errors,
            //     //isRequired: true,
            //     rules: getMinMaxValidationRules({
            //       label: "Work Phone",
            //       // min: 9,
            //       //  max: 9,
            //     }),
            //   })}
            iProps={{ addonBefore: "+971", placeholder: "Work Phone" }}
            setValue={setValue}
            valueGot={editAbleRecord?.pocWorkPhone || ""}
          />
        </Col>

        <Col span={8}>
          <InputField
            fieldname="pocEmail"
            label="Email"
            {...defaultProps}
            // {...getValidationProps({
            //   fieldName: "workPhone",
            //   errors,
            //   //isRequired: true,
            //   rules: getMinMaxValidationRules({
            //     label: "Work Phone",
            //     // min: 9,
            //     //  max: 9,
            //   }),
            // })}
            iProps={{ placeholder: "Email" }}
            setValue={setValue}
            valueGot={editAbleRecord?.pocEmail || ""}
          />
        </Col>
      </Row>
    </Card>
  );
};
